var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"screenInfo"},[_c('div',{staticClass:"screenInfo__container"},[_c('div',{staticClass:"screenInfo__iconArea"},[_c('img',{class:_vm.screenIcon})]),_c('label',{staticClass:"screenInfo__title",class:{
				__plain_color: _vm.isPlainTitle,
				'memo-screen-title': _vm.screenName === 'メモ',
			}},[_vm._v(" "+_vm._s(_vm.screenName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }